module.exports = __webpack_public_path__ + "static/aplikacja-crm-c5b545b7aeee96ef660761530ed849e7.png";